import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthenticationService } from '../../core/authentication/authentication.service';

@Component({
  selector: 'app-modal-message',
  templateUrl: './modal-message.component.html',
  styleUrls: ['./modal-message.component.scss'],
})
export class ModalMessageComponent {
  private authenticationService = inject(AuthenticationService);
  timeToDoAction$: Observable<number>;

  isCopied = false;

  params: any;

  constructor(
    private dialogRef: MatDialogRef<ModalMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.params = this.data.params || {};
    if (this.data.timeToDoAction) {
      this.timeToDoAction$ = timer(0, 1000).pipe(
        map(i => this.data.timeToDoAction - i),
        take(this.data.timeToDoAction)
      );
    }
  }

  close() {
    !this.data.disableClose && this.dialogRef.close({});
  }

  extendSession() {
    this.dialogRef.close({ extendSession: true });
  }

  logout() {
    this.authenticationService.logout();
    !this.data.disableClose && this.dialogRef.close({});
  }
}
